<script setup lang="ts">
import { BAccordion, BAccordionItem, BButton, BTab, BTabs } from 'bootstrap-vue-next';
import { computed, ref } from 'vue';

import MenteesCard from './MenteesCard.vue';
import MentorsCard from './MentorsCard.vue';

const props = withDefaults(defineProps<{
  isAdmin?: boolean;
  isOwnProfile?: boolean;
  userHandle: string;
}>(), {
  isAdmin: false,
  isOwnProfile: false,
});

const mentorCount = ref<number | null>(null);
const menteeCount = ref<number | null>(null);
const showAddMentorshipModal = ref(false);
const activeTabIndex = ref(0);

const canEdit = computed(() => props.isAdmin || props.isOwnProfile);
const isMentorsTabActive = computed(() => activeTabIndex.value === 0);

const tabTitle = (label: string, count: number | null) =>
  count !== null ? `${label} (${count})` : label;
</script>

<template>
  <BAccordion class="my-2">
    <BAccordionItem
      :visible="true"
      body-class="p-0"
    >
      <template #title>
        <div class="d-flex align-items-center justify-content-between w-100">
          <h2 class="mb-0">Mentorship</h2>

          <BButton
            v-if="canEdit && isMentorsTabActive"
            data-testid="add-mentorship-button"
            variant="outline-primary"
            size="sm"
            class="mx-2"
            @click.stop="showAddMentorshipModal = true"
          >
            Add mentorship
          </BButton>
        </div>
      </template>

      <BTabs
        v-model:index="activeTabIndex"
        class="mt-2 pt-2"
      >
        <BTab
          :title="tabTitle('Mentors', mentorCount)"
          :active="true"
        >
          <MentorsCard
            v-model:show-add-modal="showAddMentorshipModal"
            :user-handle="userHandle"
            :is-admin="isAdmin"
            :is-own-profile="isOwnProfile"
            @count-updated="mentorCount = $event"
          />
        </BTab>

        <BTab :title="tabTitle('Mentees', menteeCount)">
          <MenteesCard
            :user-handle="userHandle"
            @count-updated="menteeCount = $event"
          />
        </BTab>
      </BTabs>
    </BAccordionItem>
  </BAccordion>
</template>
